module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Divieto_di_Transito.1dfd3054.svg";